import * as React from 'react';

import CareerOutcomesModule from 'bundles/unified-description-page-common/components/modules/career-outcomes/CareerOutcomesModule';
import DataBox from 'bundles/unified-description-page-common/components/modules/career-outcomes/DataBox';
import type { ConsumerSpecializationPageFieldsFragment } from 'bundles/unified-description-page-common/queries/bff/__generated__/ConsumerSpecializationPageQuery';
import {
  getCareerOutcomesTitleForSpecialization,
  getCareerOutcomesValuePropsForSpecialization,
} from 'bundles/unified-description-page-common/utils/careerOutcomes';
import { SPECIALIZATION_NAV_ITEMS } from 'bundles/unified-description-page-common/utils/getPageNavigationLinks';

import careerOutcomesDataBoxImage from 'images/unified-description-page/career-outcomes-specialization.png';

type Props = { pageData: ConsumerSpecializationPageFieldsFragment };

export const SpecializationCareerOutcomesModuleRenderer = ({ pageData }: Props): React.ReactElement => {
  return (
    <CareerOutcomesModule
      anchorId={SPECIALIZATION_NAV_ITEMS.OUTCOMES}
      title={getCareerOutcomesTitleForSpecialization()}
      valueProps={getCareerOutcomesValuePropsForSpecialization(pageData.partners?.[0]?.name)}
      dataBox={
        <DataBox
          imageSrc={careerOutcomesDataBoxImage}
          careerGrowthInPercentage={pageData.careerOutcomes?.careerGrowthInPercentage}
        />
      }
    />
  );
};

export default SpecializationCareerOutcomesModuleRenderer;
